var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('a-carousel',{attrs:{"autoplay":true,"dotPosition":'left'}},[_c('div',[_c('img',{staticClass:"bannerImage",attrs:{"src":require('../../../assets/weapon/weaponbanner1.png'),"alt":""}})]),_vm._v(" "),_c('div',[_c('img',{staticClass:"bannerImage",attrs:{"src":require('../../../assets/weapon/weaponbanner1.png'),"alt":""}})])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a8e6322","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/daoba-match/views/program/components/Banner.vue
// module id = null
// module chunks = 